// src/hooks/useMaskAmounts.ts
import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'spent_tracker.advisorMaskAmounts';

function readInitial(): boolean {
  if (typeof window === 'undefined') return true;
  const v = window.localStorage.getItem(STORAGE_KEY);
  return v === null ? true : v === '1';
}

export function useMaskAmounts(): { masked: boolean; toggle: () => void } {
  const [masked, setMasked] = useState<boolean>(() => readInitial());

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, masked ? '1' : '0');
    } catch {
      // localStorage may be unavailable in private mode; ignore.
    }
  }, [masked]);

  const toggle = useCallback(() => setMasked((v) => !v), []);

  return { masked, toggle };
}
